// FASTag calculations for the Utilities → FASTag module.
// Balance = opening balance + recharges − tolls, so it always matches the history.

export const FASTAG_ISSUERS = [
  'Airtel Payments Bank',
  'Axis Bank',
  'Bank of Baroda',
  'HDFC Bank',
  'ICICI Bank',
  'IDFC FIRST Bank',
  'Indian Highways Management (IHMCL)',
  'IndusInd Bank',
  'Kotak Mahindra Bank',
  'State Bank of India',
  'Yes Bank',
];

const isThisMonth = (date) => {
  const now = new Date();
  const [year, month] = String(date).slice(0, 7).split('-').map(Number);
  return year === now.getFullYear() && month === now.getMonth() + 1;
};

// Totals for one tag from its entries
export const summariseTag = (tag, entries = []) => {
  let recharged = 0;
  let tolls = 0;
  let monthTolls = 0;
  let monthRecharged = 0;
  let tollCount = 0;
  entries.forEach((entry) => {
    const amount = Number(entry.amount) || 0;
    if (entry.entry_type === 'recharge') {
      recharged += amount;
      if (isThisMonth(entry.date)) monthRecharged += amount;
    } else {
      tolls += amount;
      tollCount += 1;
      if (isThisMonth(entry.date)) monthTolls += amount;
    }
  });
  const balance = (Number(tag?.opening_balance) || 0) + recharged - tolls;
  return {
    balance,
    recharged,
    tolls,
    tollCount,
    monthTolls,
    monthRecharged,
    isLow: balance < (Number(tag?.low_balance_alert) || 0),
  };
};
